module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShown) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal-box"
  }, [_c('div', {
    staticClass: "context",
    on: {
      "click": function($event) {
        _vm.btnEmit('closeModal')
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-title clearfix"
  }, [_c('span', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.btnEmit('closeModal')
      }
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content",
    domProps: {
      "textContent": _vm._s(_vm.msg)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-btn"
  }, [_c('div', {
    staticClass: "modal-btn-container",
    style: ({
      width: 230 * _vm.buttons.length + 'px'
    })
  }, _vm._l((_vm.buttons), function(button) {
    return _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      domProps: {
        "textContent": _vm._s(button.desc)
      },
      on: {
        "click": function($event) {
          _vm.btnEmit(button.func)
        }
      }
    })
  }))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-568a2b20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ActionModal.vue
// module id = 768
// module chunks = 1